export default class PublicationJobsOverages {
  constructor() {}

  index() {
    this.bindListeners();
  }

  bindListeners(){
    // eslint-disable-next-line
    N2.bindHandler("click", ".js-add, .js-remove", (e) => {
      const type = $(e.target).parent().data("type");
      const pubId = $(".js-pub-job").data("id");
      let count = $(e.target).siblings("span").text();

      let id; let url;
      if (e.target.className.includes("js-remove")) {
        count = parseInt(count) - 1
      } else {
        count = parseInt(count) + 1
      }

      if (count >= 0) {
        if ($(e.target).parent().data("overageId")) {
          id = $(e.target).parent().data("overageId");
          url = `/publication_jobs/${pubId}/overages/${id}`;
        } else {
          url = `/publication_jobs/${pubId}/overages/`;
        }
        const form = new N2Styles.manualForm(url);
        form.setUrl(url);
        form.addInput("overages[record_count]", count);
        form.addInput("overages[type]", type);

        if (id) {
          form.patch();
        } else {
          form.post();
        }
      } else {
        new N2Styles.toast("Overage count can't be negative.");
      }
    })
  }
}
